import SEO from '../components/SEO'
import { trackEvent } from '../utils/analytics'

const videoCategories = [
  {
    title: 'Hidden History',
    description: 'Videos revealing hidden history',
    videos: [
      { id: 'YfJP3yFkgJ4' },
      { id: '7VHcl_EqLew' },
      { id: '8Hc8LLKvCC8' },
      { id: 'cqcSH8FPNKk' },
      { id: 'Cm5m4ZYQHAY' },
    ],
  },
  {
    title: 'Indoctri-NATION 365',
    description: 'Videos about the book',
    videos: [
      { id: 'SCyrlyvUXQ0' },
      { id: 'dbcOd4qjOEw' },
      { id: 'uB5-mC_lV1g' },
    ],
  },
  {
    title: 'Racism Unfiltered: "White" Women Talk',
    description: 'Videos from the podcast series',
    videos: [
      { id: 'Wmor8xjriec' },
      { id: 'hzV33A9qfeY' },
      { id: 'GAUrR8QEkA0' },
    ],
  },
  {
    title: 'Important Breaking News to Follow',
    description: 'Videos showing current issues that address inequality, racism, corruption, or bigotry',
    videos: [
      { id: 'drHHJCvv2l0' },
      { id: 'Qf9W3UIVhog' },
      { id: 'OsfCPiMH1Ec' },
    ],
  },
  {
    title: 'Anti-racism 101: The Basics',
    description: 'Videos that teach the important basics of understanding American culture',
    videos: [
      { id: '2AagExvfHP8' },
    ],
  },
  {
    title: 'Interviews',
    description: "Video interviews I've done about discrimination",
    videos: [
      { id: 'rPKQwS4YrM0' },
      { id: 'HxIYnGXymDk' },
    ],
  },
]

export default function Videos() {
  return (
    <>
      <SEO
        title="Videos"
        description="Watch videos about hidden American history, Indoctri-NATION 365, and the Racism Unfiltered podcast series. Educational content on systemic racism and racial justice."
        keywords="systemic racism videos, hidden history, racial justice education, Indoctri-NATION 365, Racism Unfiltered, podcast, Kim Synergy"
        url="https://indoctrination365.com/videos"
      />
      <main className="py-16">
        <div id="top" />
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">Videos</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-6">
              Watch, learn, and share. These videos cover hidden history, the story behind the book,
              and real conversations about race in America.
            </p>
            <a
              href="https://www.youtube.com/@angrysoccermom?sub_confirmation=1"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent('youtube_subscribe_click', { location: 'videos_page' })}
              className="inline-block bg-red-600 text-white px-6 py-3 rounded-lg font-semibold text-lg hover:bg-red-700 transition-colors"
            >
              ▶ Subscribe on YouTube
            </a>
          </div>

          {videoCategories.map((category) => (
            <section key={category.title} className="mb-16">
              <h2 className="text-2xl font-bold mb-2">{category.title}</h2>
              <p className="text-gray-600 mb-6">{category.description}</p>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {category.videos.map((video) => (
                  <div
                    key={video.id}
                    className="relative w-full rounded-lg overflow-hidden shadow-md"
                    style={{ paddingBottom: '56.25%' }}
                  >
                    <iframe
                      className="absolute inset-0 w-full h-full"
                      src={`https://www.youtube.com/embed/${video.id}?rel=0&modestbranding=1`}
                      title={`${category.title} video`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            </section>
          ))}

        </div>
      </main>
    </>
  )
}
